var _rect, _path, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoUpDownGrau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "37.002px",
    height: "45.001px",
    viewBox: "0 0 37.002 45.001",
    enableBackground: "new 0 0 37.002 45.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.001,
    y: 0,
    fill: "none",
    width: 33,
    height: 45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M12.725,27.915c-0.168-0.125-0.399-0.133-0.551-0.004c-0.992,0.699-2.11,1.129-3.27,1.422l0.078-13.668 c1.133,0.309,2.227,0.758,3.192,1.48c0.152,0.121,0.39,0.121,0.558,0c0.157-0.125,0.231-0.344,0.153-0.535L6.988,0.306 C6.922,0.122,6.758,0,6.561,0C6.356-0.007,6.189,0.122,6.119,0.297l-6.087,16.23c-0.066,0.195-0.011,0.414,0.153,0.531 c0.082,0.066,0.187,0.098,0.277,0.098c0.101,0,0.199-0.023,0.273-0.086c1.004-0.699,2.125-1.145,3.282-1.441L3.938,29.313 c-1.137-0.297-2.231-0.743-3.196-1.458c-0.152-0.125-0.387-0.125-0.558,0c-0.157,0.117-0.231,0.336-0.153,0.531l5.899,16.303 c0.058,0.187,0.23,0.304,0.425,0.312c0.196,0,0.375-0.121,0.442-0.306l6.078-16.25C12.941,28.254,12.889,28.04,12.725,27.915"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.001,
    y: 0,
    fill: "none",
    width: 37,
    height: 45
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.001,
    y: 0,
    width: 37,
    height: 45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#C6C6C6",
    points: "36.221,28.773 31.682,24.238 26.471,29.45 21.26,24.238 16.721,28.773  21.932,33.988 16.721,39.2 21.26,43.738 26.471,38.527 31.682,43.738 36.221,39.2 31.01,33.988  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUpDownGrau);
export default __webpack_public_path__ + "static/media/noUpDown_Grau.76390c056f14e1808e72480b0311a93a.svg";
export { ForwardRef as ReactComponent };